export const ADD_SONG_TO_FAVORITES_LIST = 'ADD_SONG_TO_FAVORITES_LIST';
export const ADD_SONG_TO_FAVORITES_LIST_FAILED = 'ADD_SONG_TO_FAVORITES_LIST_FAILED';
export const ADD_SONG_TO_FAVORITES_LIST_REQUEST = 'ADD_SONG_TO_FAVORITES_LIST_REQUEST';
export const ADD_SONG_TO_FAVORITES_LIST_SUCCESS = 'ADD_SONG_TO_FAVORITES_LIST_SUCCESS';

export const DELETE_SELECTED_SONG = 'DELETE_SELECTED_SONG';
export const DELETE_SELECTED_SONG_FAILED = 'DELETE_SELECTED_SONG_FAILED';
export const DELETE_SELECTED_SONG_REQUEST = 'DELETE_SELECTED_SONG_REQUEST';
export const DELETE_SELECTED_SONG_SUCCESS = 'DELETE_SELECTED_SONG_SUCCESS';

export const EDIT_SONG = 'EDIT_SONG';
export const EDIT_SONG_FAILED = 'EDIT_SONG_FAILED';
export const EDIT_SONG_REQUEST = 'EDIT_SONG_REQUEST';
export const EDIT_SONG_SUCCESS = 'EDIT_SONG_SUCCESS';

export const GET_ALL_SONGS_FAILED = 'GET_ALL_SONGS_FAILED';
export const GET_ALL_SONGS_REQUEST = 'GET_ALL_SONGS_REQUEST';
export const GET_ALL_SONGS_SUCCESS = 'GET_ALL_SONGS_SUCCESS';

export const GET_COUNTRY_ARTISTS_FAILED = 'GET_COUNTRY_ARTISTS_FAILED';
export const GET_COUNTRY_ARTISTS_REQUEST = 'GET_COUNTRY_ARTISTS_REQUEST';
export const GET_COUNTRY_ARTISTS_SUCCESS = 'GET_COUNTRY_ARTISTS_SUCCESS';

export const GET_COUNTRY_SONGS_FAILED = 'GET_COUNTRY_SONGS_FAILED';
export const GET_COUNTRY_SONGS_REQUEST = 'GET_COUNTRY_SONGS_REQUEST';
export const GET_COUNTRY_SONGS_SUCCESS = 'GET_COUNTRY_SONGS_SUCCESS';

export const GET_COUNTRIES_WITH_SONGS_FAILED = 'GET_COUNTRIES_WITH_SONGS_FAILED';
export const GET_COUNTRIES_WITH_SONGS_REQUEST = 'GET_COUNTRIES_WITH_SONGS_REQUEST';
export const GET_COUNTRIES_WITH_SONGS_SUCCESS = 'GET_COUNTRIES_WITH_SONGS_SUCCESS';

export const GET_SELECTED_COUNTRY_SONGS = 'GET_SELECTED_COUNTRY_SONGS';

export const GET_GENRES_REQUEST = 'GET_GENRES_REQUEST';
export const GET_GENRES_SUCCESS = 'GET_GENRES_SUCCESS';
export const GET_GENRES_FAILED = 'GET_GENRES_FAILED';

export const GET_PLAYLIST_SONGS_REQUEST = 'GET_PLAYLIST_SONGS_REQUEST';
export const GET_PLAYLIST_SONGS_SUCCESS = 'GET_PLAYLIST_SONGS_SUCCESS';
export const GET_PLAYLIST_SONGS_FAILED = 'GET_PLAYLIST_SONGS_FAILED';

export const GET_RANDOM_SONGS_LIST_REQUEST = 'GET_RANDOM_SONGS_LIST_REQUEST';
export const GET_RANDOM_SONGS_LIST_SUCCESS = 'GET_RANDOM_SONGS_LIST_SUCCESS';
export const GET_RANDOM_SONGS_LIST_FAILED = 'GET_RANDOM_SONGS_LIST_FAILED';

export const GET_USER_FAVORITE_SONGS_REQUEST = 'GET_USER_FAVORITE_SONGS_REQUEST';
export const GET_USER_FAVORITE_SONGS_SUCCESS = 'GET_USER_FAVORITE_SONGS_SUCCESS';
export const GET_USER_FAVORITE_SONGS_FAILED = 'GET_USER_FAVORITE_SONGS_FAILED';

export const GET_USER_UPLOADED_SONGS_REQUEST = 'GET_USER_UPLOADED_SONGS_REQUEST';
export const GET_USER_UPLOADED_SONGS_SUCCESS = 'GET_USER_UPLOADED_SONGS_SUCCESS';
export const GET_USER_UPLOADED_SONGS_FAILED = 'GET_USER_UPLOADED_SONGS_FAILED';

export const REMOVE_SONG_FROM_FAVORITES_LIST = 'REMOVE_SONG_FROM_FAVORITES_LIST';
export const REMOVE_SONG_FROM_FAVORITES_LIST_FAILED = 'REMOVE_SONG_FROM_FAVORITES_LIST_FAILED';
export const REMOVE_SONG_FROM_FAVORITES_LIST_REQUEST = 'REMOVE_SONG_FROM_FAVORITES_LIST_REQUEST';
export const REMOVE_SONG_FROM_FAVORITES_LIST_SUCCESS = 'REMOVE_SONG_FROM_FAVORITES_LIST_SUCCESS';

export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';

export const SELECT_SONG_TO_EDIT = 'SELECT_SONG_TO_EDIT';
export const SELECT_SONG_TO_VIEW_INFO = 'SELECT_SONG_TO_VIEW_INFO';

export const UPDATE_EDIT_SONG_VALUE = 'UPDATE_EDIT_SONG_VALUE';


